export default "__VITE_ASSET__Bm3uGJfG__"